import React, { useState, useEffect, useMemo } from 'react';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';

import Chart from "react-apexcharts";
import { Box, Typography } from "@mui/material";
import TextField from '@material-ui/core/TextField';

import api from '../../../../../services/api';





const styles = {
  card: {
    borderRadius: '12px',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '200px',
  },
  purpleCard: {
    backgroundColor: '#6a1b9a',
    color: '#fff',
  },
  blueCard: {
    backgroundColor: '#0288d1',
    color: '#fff',
  },
  iconBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  iconBackground: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    borderRadius: '8px',
    padding: '8px',
  },
  graphBox: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    borderRadius: '8px',
    height: '40px',
    marginTop: '8px',
  },

};


export default function DashboardLancamento({ flag }) {


  const [loading, setLoading] = useState(true);

  const [data, setData] = useState({
    totaldespesa: 0,
    totaldespesapaga: 0,
    totaldespesaapagar: 0,
    totalreceita: 0,
    totalreceitapaga: 0,
    totalreceitaapagar: 0
  });


  const hoje = new Date();

  const [dia, setDia] = useState(null);
  const [mes, setMes] = useState(null);
  const [ano, setAno] = useState(null);


  async function listarLancamentos() {


    try {
      const token = Cookies.get('token');
      const id_usuario = Cookies.get('id_usuario');

      const headers = {
        'Authorization': 'Bearer ' + token
      };

      const regra = Cookies.get('regra');
      if (regra.includes("ADMIN")) {

        let response = await api.get(
          `v1/protected/financeiro/lancamentos/listardashboard?dia=${dia || ''}&mes=${mes || ''}&ano=${ano || ''}`,
          { headers }
        );

        setData(response.data); // agora usa a resposta correta
        setLoading(false);

      }

    } catch (_err) {
      console.log("Erro ao listar objetos: " + _err);
      setLoading(false);
    }
  }






  useEffect(() => {
    // Função auxiliar para validar os filtros
    const filtrosValidos = () => {
      // Se vazio ou null, ok
      const diaValido = !dia || (Number(dia) >= 1 && Number(dia) <= 31);
      const mesValido = !mes || (Number(mes) >= 1 && Number(mes) <= 12);
      const anoValido = !ano || (Number(ano) >= 2000);

      return diaValido && mesValido && anoValido;
    };

    if (filtrosValidos()) {
      listarLancamentos();
    } else {
      console.warn("Filtros inválidos: dia, mês ou ano incorretos.");
    }
  }, [dia, mes, ano]);




  if (loading || !data) return <Typography>Carregando...</Typography>;

  // Preparando séries e cores de Despesas
  const despesaSeries = data ? [
    data.totaldespesapaga,    // vermelho
    data.totaldespesaapagar   // laranja
  ] : [];


  // Preparando séries e cores de Receitas
  const receitaSeries = data ? [
    data.totalreceitapaga,    // verde
    data.totalreceitaapagar   // amarelo
  ] : [];



  const despesaOptions = {
    labels: ["Despesa Paga", "Despesa a Pagar"],
    colors: ["#FF4C4C", "#FFA500"], // vermelho, laranja
    dataLabels: {
      enabled: true,
      formatter: (val, opts) => {
        const label = opts.w.config.labels[opts.seriesIndex];
        const valor = opts.w.globals.series[opts.seriesIndex];
        return `${label}: R$ ${valor.toLocaleString("pt-BR")} (${val.toFixed(1)}%)`;
      }
    },
    legend: {
      position: "bottom",
      labels: {
        colors: "#000000" // legenda preta
      }
    },
    tooltip: {
      theme: "light", // deixa o fundo claro
      style: {
        fontSize: '14px',
        fontFamily: 'Arial',
        color: '#000000' // texto preto
      },
      y: {
        formatter: val => `R$ ${val.toLocaleString("pt-BR")}`
      }
    }
  };

  const receitaOptions = {
    labels: ["Receita Paga", "Receita a Receber"],
    colors: ["#4CAF50", "#FFD700"], // verde, amarelo
    dataLabels: {
      enabled: true,
      formatter: (val, opts) => {
        const label = opts.w.config.labels[opts.seriesIndex];
        const valor = opts.w.globals.series[opts.seriesIndex];
        return `${label}: R$ ${valor.toLocaleString("pt-BR")} (${val.toFixed(1)}%)`;
      }
    },
    legend: {
      position: "bottom",
      labels: {
        colors: "#000000" // legenda preta
      }
    },
    tooltip: {
      theme: "light",
      style: {
        fontSize: '14px',
        fontFamily: 'Arial',
        color: '#000000' // texto preto
      },
      y: {
        formatter: val => `R$ ${val.toLocaleString("pt-BR")}`
      }
    }
  };

  return (
    <div>


      {/* Filtros centralizados */}
      <Grid container spacing={2} justifyContent="center" sx={{ mb: 2 }}>
        <Grid item xs={3}>
          <TextField
            label="Dia"
            value={dia}
            onChange={e => setDia(e.target.value)}
            inputProps={{ maxLength: 2 }}
            fullWidth
            onBlur={() => {
              // Quando o usuário sair do campo, adiciona o 0 à esquerda se precisar
              if (dia.length === 1) setDia(dia.padStart(2, '0'));
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            label="Mês"
            value={mes}
            onChange={e => setMes(e.target.value)}
            inputProps={{ maxLength: 2 }}
            fullWidth
            onBlur={() => {
              // Quando o usuário sair do campo, adiciona o 0 à esquerda se precisar
              if (mes.length === 1) setMes(mes.padStart(2, '0'));
            }}
          />
        </Grid>

        <Grid item xs={3}>
          <TextField
            label="Ano"
            value={ano}
            onChange={e => setAno(e.target.value)}
            inputProps={{ maxLength: 4 }}
            fullWidth
          />
        </Grid>
      </Grid>

      <Box sx={{ display: "flex", gap: 4, justifyContent: "center", mt: 4 }}>

        {(flag === 2 || flag === 0) &&

          data && (
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="h6" gutterBottom>Despesas</Typography>
              <Chart
                options={despesaOptions}
                series={despesaSeries}
                type="pie"
                width={500}
              />
              <Typography>Total: R$ {data.totaldespesa.toLocaleString("pt-BR")}</Typography>
            </Box>
          )
        }

        {(flag === 2 || flag === 1) &&
          data && (
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="h6" gutterBottom>Receitas</Typography>
              <Chart
                options={receitaOptions}
                series={receitaSeries}
                type="pie"
                width={500}
              />
              <Typography>Total: R$ {data.totalreceita.toLocaleString("pt-BR")}</Typography>
            </Box>
          )
        }
      </Box>


    </div >
  );
}



